/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */

// React & PropTypes
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// MUI Components
import Grid from "@mui/material/Grid2";
import {
  Divider,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";

// Internal Components
// - Core Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DetailList from "components/DetailList";
import Danger from "components/Danger";
import FormField from "components/FormField";
import MDButton from "components/MDButton";

// - AutoComplete Components
import GreenSwitch from "components/AutoComplete/GreenSwitch";
import BadgePicker from "components/AutoComplete/BadgePicker";
import PickupTypePicker from "components/AutoComplete/PickupTypePicker";
import PinsPicker from "components/AutoComplete/PinsPicker";

// - Async Components
import PinPicker from "components/AsyncSelect/PinPicker";

// - Specialized Components
import ShowHideComponentsPicker from "components/ShowHideComponentsPicker";
import DynamicRadioGroup from "components/DynamicRadioGroup";
import AvailabilityDurationPanel from "components/AvailabilityDurationPanel";
import AvailabilityPickupPanel from "components/AvailabilityPickupPanel";

// Constants
import {
  healthRestrictions,
  radioOptions,
  durationOptions,
  ticketDurationOptions,
  accompaniedOptions,
  pickupOptions,
} from "./components/constants";

// Local Components
import InclusionExclusion from "./components/inclusionExclusion";
import LanguagesSection from "./components/LanguagesSection";
import PhysicalRestrictionsSection from "./components/PhysicalRestrictionsSection";
import StopsPart from "./components/TicketDetailsSection/stopsPart";

const Content = ({
  formData,
  editPage = false,
  detailPage = true,
  selectedVenue = {},
  handleVenueChange = () => {},
  selectedPin = {},
  setSelectedPin = () => {},
  setSelectedVenue = () => {},
  selectedPickupPoint = {},
  setSelectedPickupPoint = () => {},
  handlePinChange = () => {},
  handlePickupPointChange = () => {},
  selectedTitleInc = {},
  setSelectedTitleInc = () => {},
  selectedTitleExc = {},
  setSelectedTitleExc = () => {},
  handleTitleIncChange = () => {},
  handleTitleExcChange = () => {},
}) => {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const {
    isOneVenue,
    venues,
    durationRadio,
    day,
    hour,
    min,
    from,
    to,
    day2,
    hour2,
    min2,
    from2,
    to2,
    durationRadio2,
    description,
    languages,
    skipTheLine,
    containStops,
    titlePkr,
    badge,
    pin,
    pinsStart,
    pinsEnd,
    pickupOptionType,
    pickupPoint,
    pickupType,
    allowCustomTravelerPickup,
    additionalPickupInfo,
    minutesBeforeDepartureTimeForPickup,
    // additionalInfo,
    top,
    highlight,
    accompanied,
    minTravelersPerBooking,
    maxTravelersPerBooking,
    // selectedRadio,
  } = formField;
  const {
    isOneVenue: isOneVenueV,
    venues: venuesV,
    durationRadio: durationRadioV,
    durationRadio2: durationRadio2V,
    description: descriptionV,
    day: dayV,
    hour: hourV,
    min: minV,
    from: fromV,
    to: toV,
    day2: day2V,
    hour2: hour2V,
    min2: min2V,
    from2: from2V,
    to2: to2V,
    // timeType2: timeType2V,
    languages: languagesV,
    skipTheLine: skipTheLineV,
    containStops: containStopsV,
    accompanied: accompaniedV,
    // exclusions: exclusionsV,
    // inclusions: inclusionsV,
    titlePkr: titlePkrV,
    titlePkrExc: titlePkrExcV,
    typeText: typeTextV,
    typeTextExc: typeTextExcV,
    allowCustomTravelerPickup: allowCustomTravelerPickupV,
    additionalPickupInfo: additionalPickupInfoV,
    minutesBeforeDepartureTimeForPickup: minutesBeforeDepartureTimeForPickupV,
    minTravelersPerBooking: minTravelersPerBookingV,
    maxTravelersPerBooking: maxTravelersPerBookingV,
    // additionalInfo: additionalInfoV,
    top: topV,
    highlight: highlightV,
    pickupOptionType: pickupOptionTypeV,
    physicalDifficultyLevel: physicalDifficultyLevelV,
    pinsStart: pinsStartV,
    pinsEnd: pinsEndV,
  } = values;

  const [selectedDuration, setSelectedDuration] = useState(durationRadioV);
  const [selected2Duration, setSelected2Duration] = useState(durationRadio2V);

  // const [travelerPickup, setTravelerPickup] = useState(values.travelerPickup || []);
  const [timeType, setTimeType] = useState("MINUTE");
  // const [timeType2, setTimeType2] = useState("MINUTE");
  const [restrictions, setRestrictions] = useState([]);
  const [startsPins, setStartsPins] = useState(values?.logistics?.start || []);
  const [endsPins, setEndsPins] = useState(values?.logistics?.end || []);
  const [selectedAdditionalInfo, setSelectedAdditionalInfo] = useState([
    "WHEELCHAIR_ACCESSIBLE",
    "STROLLER_ACCESSIBLE",
    "PETS_WELCOME",
    "INFANTS_MUST_SIT_ON_LAPS",
  ]);
  // const [allItineraryItems, setAllItineraryItems] = useState([]);

  const [validationMessage, setValidationMessage] = useState("");

  useEffect(() => {
    const vals = values?.logistics?.start
      ?.map((item) => item.pin?.id)
      .filter((id) => id !== undefined);
    setStartsPins(vals);
  }, [values?.logistics?.start]);

  useEffect(() => {
    const vals = values?.logistics?.end
      ?.map((item) => item.pin?.id)
      .filter((id) => id !== undefined);
    setEndsPins(vals);
  }, [values?.logistics?.end]);

  const getBadgeLabel = (badgeVal) => {
    switch (badgeVal) {
      case "insider":
        return "Insider tip";
      case "new":
        return "New";
      case "exclusive":
        return "Exclusive";
      case "top_seller":
        return "Top seller";
      case "likely_to_sell_out":
        return "Likely to sell out";
      case "excellent_quality":
        return "Excellent quality";
      case "best_value":
        return "Best value";
      case "best_seller":
        return "Best seller";
      case "once_in_a_lifetime":
        return "Once in a lifetime";
      case "special_offer":
        return "Special offer";
      default:
        return null;
    }
  };

  const helperTextStyle = {
    fontSize: "0.875rem",
    color: "black",
  };

  const handleDurationChange = (name, value) => {
    setSelectedDuration(value);
    setFieldValue(name, value);
    if (value === "flexibleDuration") {
      setFieldValue("itinerary.duration.durationType", "MINUTE");
    }
  };

  const handleDuration2Change = (name, value) => {
    setSelected2Duration(value);
    setFieldValue(name, value);
    setFieldValue("day2", "");
    setFieldValue("hour2", "");
    setFieldValue("min2", "");
    setFieldValue("from2", "");
    setFieldValue("to2", "");
    setFieldValue("timeType2", "MINUTE");
  };

  const handleAddInclusion = () => {
    if (titlePkrV?.label?.length > 0) {
      const isOther = titlePkrV?.value === "OTHER"; // Assuming 'other' is the value for "other"
      const newInclusion = {
        type: { label: titlePkrV?.label, value: titlePkrV?.value },
        description: isOther ? typeTextV : titlePkrV?.label && typeTextV, // Use typeTextV when "other" is selected
      };

      // Check if inclusion already exists, including "other" with the same title
      const inclusionExists = values?.inclusions.some(
        (inc) =>
          inc.type.value === newInclusion.type.value &&
          (isOther ? inc.description === typeTextV : true) // Compare the description if "other" is selected
      );
      const exclusionExists = values?.exclusions.some(
        (exc) =>
          exc.type.value === newInclusion.type.value &&
          (isOther ? exc.description === typeTextV : true)
      );

      if (inclusionExists || exclusionExists) {
        setValidationMessage(
          isOther
            ? "This 'other' inclusion with the same title already exists in inclusions or exclusions!"
            : "Inclusion exists already  or is added as an exclusion!"
        );
        return;
      }

      const updatedItems = [...values?.inclusions, newInclusion];
      setFieldValue("inclusions", updatedItems);

      // Reset fields after adding
      setSelectedTitleInc({});
      setFieldValue("titlePkr", {});
      setFieldValue("typeText", "");
      setValidationMessage(""); // Clear validation message on successful add
    }
  };

  const handleAddExclusion = () => {
    if (titlePkrExcV?.label?.length > 0) {
      const isOther = titlePkrExcV?.value === "OTHER"; // Assuming 'other' is the value for "other"
      const newExclusion = {
        type: { label: titlePkrExcV?.label, value: titlePkrExcV?.value },
        description: isOther ? typeTextExcV : titlePkrExcV?.label && typeTextExcV, // Use typeTextExcV when "other" is selected
      };

      // Check if exclusion already exists, including "other" with the same title
      const exclusionExists = values?.exclusions.some(
        (exc) =>
          exc.type.value === newExclusion.type.value &&
          (isOther ? exc.description === typeTextExcV : true)
      );
      const inclusionExists = values?.inclusions.some(
        (inc) =>
          inc.type.value === newExclusion.type.value &&
          (isOther ? inc.description === typeTextExcV : true)
      );

      if (exclusionExists || inclusionExists) {
        setValidationMessage(
          isOther
            ? "This 'other' exclusion with the same title already exists in inclusions or exclusions!"
            : "Exclusion exists already or is added as an inclusion!"
        );
        return;
      }

      const updatedItems = [...values?.exclusions, newExclusion];
      setFieldValue("exclusions", updatedItems);

      // Reset fields after adding
      setSelectedTitleExc({});
      setFieldValue("titlePkrExc", {});
      setFieldValue("typeTextExc", "");
      setValidationMessage(""); // Clear validation message on successful add
    }
  };

  const handleAdditionalInfoChange = (name, value) => {
    setSelectedAdditionalInfo((prevInfo) => {
      let updatedInfo;

      if (value === "no") {
        // Remove the name from the array
        updatedInfo = prevInfo.filter((info) => info !== name);
      } else if (value === "yes") {
        // Add the name to the array if it's not already there
        updatedInfo = prevInfo.includes(name) ? prevInfo : [...prevInfo, name];
      } else {
        updatedInfo = prevInfo;
      }

      // Set the additionalInfo field in the form
      setFieldValue("additionalInfo", updatedInfo);
      return updatedInfo;
    });
  };

  const handleHealthRestrictionChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setRestrictions([...restrictions, value]);
      setFieldValue("healthRestrictions", [...restrictions, value]);
    } else {
      setRestrictions(restrictions.filter((restriction) => restriction !== value));
      setFieldValue(
        "healthRestrictions",
        restrictions.filter((restriction) => restriction !== value)
      );
    }
  };

  const isEmpty = (value) => value === undefined || value === null || value === "";

  const handleAddVenue = () => {
    // if (!selectedPin || !selectedPin.value) {
    //   setValidationMessage("Selected Pin is required.");
    //   return;
    // }

    // // Check if selectedVenue is provided
    // if (!selectedVenue || !selectedVenue.value) {
    //   setValidationMessage("Selected Venue is required.");
    //   return;
    // }

    if (!descriptionV || descriptionV.trim() === "") {
      setValidationMessage("Description is required.");
      return;
    }

    // Updated validation based on selectedDuration
    if (selectedDuration === "specificDuration") {
      if (isEmpty(dayV) || isEmpty(hourV) || isEmpty(minV)) {
        setValidationMessage("Day, Hour, and Minute are required.");
        return;
      }
    } else if (isEmpty(fromV) || isEmpty(toV)) {
      setValidationMessage("From and To are required.");
      return;
    }

    // Clear validation message on successful addition
    setValidationMessage("");

    const newItem = {
      pointOfInterestLocation: {
        pin: { id: selectedPin.value, label: selectedPin?.label },
        attractionId: {
          id: selectedVenue?.value || venuesV?.value,
          label: selectedVenue?.label || venuesV?.label,
        },
      },
      duration:
        selectedDuration === "specificDuration"
          ? {
              day: dayV,
              hour: hourV,
              minute: minV,
            }
          : {
              from: fromV,
              to: toV,
              timeType,
            },
      description: descriptionV,
    };

    const updatedItems = [...values?.itineraryItems, newItem];
    setFieldValue("itineraryItems", updatedItems);

    // Reset fields after adding

    setTimeType("MINUTE");
    setSelectedPin({});
    setSelectedVenue({});
    setSelectedPickupPoint({});
    setFieldValue("description", "");
    setFieldValue("day", "");
    setFieldValue("hour", "");
    setFieldValue("min", "");
    setFieldValue("from", "");
    setFieldValue("to", "");
    setFieldValue("pin", {});
    setFieldValue("venues", {});
  };

  const handleAddPickup = () => {
    const newPin = {
      pin: { id: values?.pickupPoint?.value, label: values?.pickupPoint?.label },
      pickupType: values?.pickupType?.value,
    };

    // Merge new pin with the existing pins
    const updatedPins = [...(values?.logistics?.travelerPickup?.pins || []), newPin];

    // Update travelerPickup state and Formik values
    // setTravelerPickup(updatedTravelerPickup);
    setFieldValue("logistics.travelerPickup.pins", updatedPins); // Only update pins in Formik state

    // Reset fields after adding
    setSelectedPickupPoint({});
    setFieldValue("pickupPoint", {});
    setFieldValue("pickupType", {});
    // setFieldValue("pickupOptionType", "PICKUP_EVERYONE");
    // Optionally reset other fields if needed:
    // setFieldValue("allowCustomTravelerPickup", false);
    // setFieldValue("minutesBeforeDepartureTimeForPickup", "");
    // setFieldValue("additionalPickupInfo", "");
  };

  return (
    <>
      <ShowHideComponentsPicker title="Ticket Details">
        {detailPage && editPage ? (
          <DetailList
            data={{
              itinerary: values?.itinerary,
              ticketDuration: values?.itinerary?.duration?.variableDurationFromMinutes
                ? `From ${values?.itinerary?.duration?.variableDurationFromMinutes} - To ${values?.itinerary?.duration?.variableDurationToMinutes} (minutes)`
                : `${
                    values?.itinerary?.duration?.day ? values?.itinerary?.duration?.day : 0
                  } day(s), ${
                    values?.itinerary?.duration?.hour ? values?.itinerary?.duration?.hour : 0
                  } hour(s), ${
                    values?.itinerary?.duration?.minute ? values?.itinerary?.duration?.minute : 0
                  } minute(s)`,
              DoChildrenNeedToBeAccompaniedByAtLeastOneAdultOrSenior:
                values?.bookingRequirements?.requiresAdultForBooking === true ? "yes" : "no",
              minTravelersPerBooking: values?.bookingRequirements?.minTravelersPerBooking,
              maxTravelersPerBooking: values?.bookingRequirements?.maxTravelersPerBooking,
              requiresAdultForBooking: values?.requiresAdultForBooking,
              skipTheLine: values?.itinerary?.skipTheLine,
            }}
          />
        ) : (
          <MDBox mt={1.625}>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12 }}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <GreenSwitch
                        checked={containStopsV}
                        name={containStops.name}
                        onChange={(event) => setFieldValue("containStops", event.target.checked)}
                      />
                    }
                    label="Stops"
                  />
                </FormGroup>
              </Grid>
              {(containStopsV || values?.itinerary?.itineraryItems?.length > 0) && (
                <Grid size={{ xs: 12 }}>
                  <StopsPart
                    isOneVenue={isOneVenue}
                    isOneVenueV={isOneVenueV}
                    containStopsV={containStopsV}
                    setFieldValue={setFieldValue}
                    values={values}
                    handlePinChange={handlePinChange}
                    selectedPin={selectedPin}
                    venues={venues}
                    venuesV={venuesV}
                    handleVenueChange={handleVenueChange}
                    selectedVenue={selectedVenue}
                    pin={pin}
                  />
                </Grid>
              )}
            </Grid>
            {/* Duration */}
            {(containStopsV || values?.itinerary?.itineraryItems?.length > 0) && (
              <Grid size={{ xs: 12 }} mt={2}>
                <DynamicRadioGroup
                  groupLabel={durationRadio.label}
                  name={durationRadio.name}
                  value={selectedDuration}
                  options={durationOptions}
                  setFieldValue={handleDurationChange}
                />
              </Grid>
            )}
            {containStopsV || values?.itinerary?.itineraryItems?.length > 0 ? (
              selectedDuration === "specificDuration" ? (
                <Grid container spacing={3}>
                  <Grid size={{ xs: 4 }}>
                    <FormField
                      type={day.type}
                      label={day.label}
                      name={day.name}
                      isPadding={false}
                      value={dayV}
                      placeholder={day.placeholder}
                      // error={errors.day && touched.day}
                      success={dayV?.length > 0 && !errors.day}
                    />
                  </Grid>
                  <Grid size={{ xs: 4 }}>
                    <FormField
                      type={hour.type}
                      label={hour.label}
                      name={hour.name}
                      isPadding={false}
                      value={hourV}
                      placeholder={hour.placeholder}
                      // error={errors.hour && touched.hour}
                      success={hourV?.length > 0 && !errors.hour}
                    />
                  </Grid>
                  <Grid size={{ xs: 4 }}>
                    <FormField
                      type={min.type}
                      label={min.label}
                      name={min.name}
                      value={minV}
                      isPadding={false}
                      placeholder={min.placeholder}
                      // error={errors.min && touched.min}
                      success={minV?.length > 0 && !errors.min}
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={3}>
                  <Grid size={{ xs: 4 }}>
                    <FormField
                      type={from.type}
                      label={from.label}
                      name={from.name}
                      value={fromV}
                      placeholder={from.placeholder}
                      isPadding={false}
                      // error={errors.from && touched.from}
                      success={fromV?.length > 0 && !errors.from}
                    />
                  </Grid>
                  <Grid size={{ xs: 4 }}>
                    <FormField
                      type={to.type}
                      label={to.label}
                      name={to.name}
                      value={toV}
                      isPadding={false}
                      placeholder={to.placeholder}
                      // error={errors.to && touched.to}
                      success={toV?.length > 0 && !errors.to}
                    />
                  </Grid>
                  <Grid size={{ xs: 4 }}>
                    <Select
                      value={timeType}
                      onChange={(e) => setTimeType(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="MINUTE">Minute</MenuItem>
                      <MenuItem value="HOUR">Hour</MenuItem>
                      <MenuItem value="DAY">Day</MenuItem>
                    </Select>
                  </Grid>
                </Grid>
              )
            ) : null}
            {containStopsV && (
              <>
                <Grid size={{ xs: 12 }}>
                  <FormField
                    type={description.type}
                    label={description.label}
                    name={description.name}
                    value={descriptionV}
                    multiline
                    outlined
                    rows={5}
                    placeholder={description.placeholder}
                    // error={errors.description && touched.description}
                    success={descriptionV?.length > 0 && !errors.description}
                  />
                  {validationMessage && <Danger validation={validationMessage} />}
                </Grid>
                <Grid size={{ xs: 12 }} mt={2}>
                  <MDButton
                    key={values?.itineraryItems?.length}
                    variant="contained"
                    color="secondary"
                    onClick={handleAddVenue}
                    disabled={values?.itineraryItems?.length === 1 && isOneVenueV === "no"}
                  >
                    Add
                  </MDButton>
                  <Danger validation={errors?.itineraryItems} />
                </Grid>
              </>
            )}

            <Grid mt={2} size={{ xs: 12 }}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <GreenSwitch
                      checked={
                        skipTheLineV || values?.skipTheLine || values?.itinerary?.skipTheLine
                      }
                      name={skipTheLine.name}
                      onChange={(event) => setFieldValue("skipTheLine", event.target.checked)}
                    />
                  }
                  label="Skip the line"
                />
              </FormGroup>
            </Grid>

            <Divider
              sx={{ height: "1px", width: "100%", backgroundColor: "gray", margin: "30px 0 0 0" }}
            />
            {(containStopsV || values?.itinerary?.itineraryItems?.length > 0) && (
              <Grid container alignItems="end" sx={{ marginBottom: "30px" }}>
                <Grid size={{ xs: 12 }}>
                  {values?.itineraryItems?.length > 0 ||
                  values?.itinerary?.itineraryItems?.length > 0 ? (
                    <AvailabilityDurationPanel
                      setFieldValue={setFieldValue}
                      availabilities={values?.itineraryItems}
                    />
                  ) : (
                    <MDBox sx={{ marginTop: "30px" }}>
                      <MDTypography variant="h5">No Availability Found!</MDTypography>
                      {errors?.availabilities && touched?.availabilities && (
                        <Danger validation={errors?.availabilities} />
                      )}
                    </MDBox>
                  )}
                </Grid>
              </Grid>
            )}
            {/* Ticket Duration */}
            <Grid size={{ xs: 12 }} mt={2}>
              <DynamicRadioGroup
                groupLabel={durationRadio2.label}
                name={durationRadio2.name}
                value={durationRadio2V || selected2Duration}
                options={ticketDurationOptions}
                setFieldValue={handleDuration2Change}
              />
            </Grid>
            {durationRadio2V === "specificDuration" ? (
              <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid size={{ xs: 4 }}>
                  <FormField
                    type={day2.type}
                    label={day2.label}
                    name={day2.name}
                    value={day2V}
                    isPadding={false}
                    placeholder={day2.placeholder}
                    // error={errors.day && touched.day}
                    success={day2V?.length > 0 && !errors.day2}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <FormField
                    type={hour2.type}
                    label={hour2.label}
                    name={hour2.name}
                    value={hour2V}
                    isPadding={false}
                    placeholder={hour2.placeholder}
                    // error={errors.hour && touched.hour}
                    success={hour2V?.length > 0 && !errors.hour2}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <FormField
                    type={min2.type}
                    label={min2.label}
                    name={min2.name}
                    value={min2V}
                    isPadding={false}
                    placeholder={min2.placeholder}
                    // error={errors.min2 && touched.min2}
                    success={min2V?.length > 0 && !errors.min2}
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={3}>
                <Grid size={{ xs: 4 }}>
                  <FormField
                    type={from2.type}
                    label={from2.label}
                    name={from2.name}
                    value={from2V}
                    isPadding={false}
                    placeholder={from.placeholder}
                    // error={errors.from && touched.from}
                    success={from2V?.length > 0 && !errors.from2}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <FormField
                    type={to2.type}
                    label={to2.label}
                    name={to2.name}
                    value={to2V}
                    isPadding={false}
                    placeholder={to2.placeholder}
                    // error={errors.to && touched.to}
                    success={toV?.length > 0 && !errors.to}
                  />
                </Grid>
              </Grid>
            )}
            <Grid size={{ xs: 12 }}>
              <DynamicRadioGroup
                groupLabel={accompanied.label}
                name={accompanied.name}
                value={accompaniedV || values?.bookingRequirements?.requiresAdultForBooking}
                options={accompaniedOptions}
                setFieldValue={setFieldValue}
              />
            </Grid>
            <Grid container size={{ xs: 12 }} spacing={3}>
              <Grid size={{ xs: 5 }}>
                <FormField
                  type={minTravelersPerBooking.type}
                  label={minTravelersPerBooking.label}
                  name={minTravelersPerBooking.name}
                  value={
                    minTravelersPerBookingV || values?.bookingRequirements?.minTravelersPerBooking
                  }
                  placeholder={minTravelersPerBooking.placeholder}
                  isPadding={false}
                  error={errors.minTravelersPerBooking && touched.minTravelersPerBooking}
                  success={minTravelersPerBookingV?.length > 0 && !errors.minTravelersPerBooking}
                />
              </Grid>
              <Grid size={{ xs: 5 }}>
                <FormField
                  type={maxTravelersPerBooking.type}
                  label={maxTravelersPerBooking.label}
                  name={maxTravelersPerBooking.name}
                  value={
                    maxTravelersPerBookingV || values?.bookingRequirements?.maxTravelersPerBooking
                  }
                  placeholder={maxTravelersPerBooking.placeholder}
                  isPadding={false}
                  error={errors.maxTravelersPerBooking && touched.maxTravelersPerBooking}
                  success={maxTravelersPerBookingV?.length > 0 && !errors.maxTravelersPerBooking}
                />
              </Grid>
            </Grid>
          </MDBox>
        )}
      </ShowHideComponentsPicker>
      <ShowHideComponentsPicker title="Languages">
        {" "}
        {detailPage && editPage ? (
          <DetailList
            data={{
              Languages: languagesV?.map((lang) => lang.name).join(", "),
            }}
          />
        ) : (
          <LanguagesSection
            detailPage={detailPage}
            editPage={editPage}
            values={values}
            errors={errors}
            touched={touched}
            setFieldValue={setFieldValue}
            languagesV={languagesV}
            languages={languages}
          />
        )}
      </ShowHideComponentsPicker>
      <ShowHideComponentsPicker title="Inclusions & Exclusions">
        {detailPage && editPage ? (
          <DetailList
            data={{
              exclusions: values?.exclusions,
              inclusions: values?.inclusions,
            }}
          />
        ) : (
          <InclusionExclusion
            values={values}
            setFieldValue={setFieldValue}
            handleAddInclusion={handleAddInclusion}
            handleAddExclusion={handleAddExclusion}
            validationMessage={validationMessage}
            titlePkr={titlePkr}
            errors={errors}
            touched={touched}
            selectedTitleInc={selectedTitleInc}
            selectedTitleExc={selectedTitleExc}
            handleTitleIncChange={handleTitleIncChange}
            handleTitleExcChange={handleTitleExcChange}
          />
        )}
      </ShowHideComponentsPicker>
      <ShowHideComponentsPicker title="Meeting & pickup points">
        {detailPage && editPage ? (
          <DetailList
            data={{
              logistics: values?.logistics,
              TravellersDefineTheirPickupPoints:
                values?.logistics?.travelerPickup?.allowCustomTravelerPickup,
              additionalPickupInfo: values?.logistics?.travelerPickup?.additionalInfo,
              PickupBefore: `${
                values?.logistics?.travelerPickup?.minutesBeforeDepartureTimeForPickup || 0
              } minutes`,
            }}
          />
        ) : (
          <MDBox mt={1.625}>
            <Grid size={{ xs: 12 }}>
              <PinsPicker
                pins={pinsStart}
                pinsV={pinsStartV || startsPins}
                fieldName="pinsStart"
                setFieldValue={setFieldValue}
                error={errors.pinsStartV && touched.pinsStartV}
                success={values?.pinsStart?.length > 0 && !errors.pinsStart}
                // selectedTag={selectedTag}
              />
            </Grid>{" "}
            <Grid size={{ xs: 12 }}>
              <PinsPicker
                pins={pinsEnd}
                pinsV={pinsEndV || endsPins}
                fieldName="pinsEnd"
                setFieldValue={setFieldValue}
                error={errors.pinsEndV && touched.pinsEndV}
                success={values?.pinsEnd?.length > 0 && !errors.pinsEnd}
                // selectedTag={selectedTag}
              />
            </Grid>{" "}
            <MDTypography variant="h6" style={{ marginTop: "5px", marginRight: "0.5rem" }}>
              Pickup information:
            </MDTypography>
            <Grid size={{ xs: 12 }}>
              <DynamicRadioGroup
                value={pickupOptionTypeV}
                options={pickupOptions}
                name={pickupOptionType.name}
                setFieldValue={setFieldValue}
                groupLabel="Pickup Option type:"
                disabled={false}
              />
            </Grid>
            {(pickupOptionTypeV === "PICKUP_EVERYONE" ||
              values?.logistics?.travelerPickup?.pickupOptionType === "PICKUP_EVERYONE" ||
              values?.logistics?.travelerPickup?.pickupOptionType ===
                "PICKUP_AND_MEET_AT_START_POINT" ||
              pickupOptionTypeV === "PICKUP_AND_MEET_AT_START_POINT") && (
              <>
                <Grid container size={{ xs: 12 }}>
                  <Grid size={{ xs: 12 }}>
                    {" "}
                    <Typography
                      style={{ wordBreak: "break-word", fontSize: "0.875rem", fontWeight: 400 }}
                    >
                      {pickupPoint.label}
                    </Typography>
                    <PinPicker
                      isClearable
                      // pin={pin}
                      isPickupPoint
                      handleChange={handlePickupPointChange}
                      setFieldValue={setFieldValue}
                      selectedPin={selectedPickupPoint || {}}
                    />
                    {/* {errors?.parent && touched?.parent && <Danger validation={errors?.parent} />} */}
                  </Grid>
                  <Grid size={{ xs: 12 }} mt={3}>
                    <PickupTypePicker
                      pickupType={pickupType}
                      pickupTypeV={values?.pickupType || {}}
                      setFieldValue={setFieldValue}
                      // error={errors.pickupType && touched.pickupType}
                      success={values?.pickupType && !errors.pickupType}
                    />
                  </Grid>
                </Grid>{" "}
              </>
            )}{" "}
            {pickupOptionTypeV !== "MEET_EVERYONE_AT_START_POINT" && (
              <>
                <Grid size={{ xs: 12 }} mt={2}>
                  <MDButton
                    key={values?.travelerPickup?.length}
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      if (values?.pickupType?.label || values?.pickupPoint?.label)
                        handleAddPickup();
                    }}
                  >
                    Add
                  </MDButton>
                </Grid>
                <Divider
                  sx={{
                    height: "1px",
                    width: "100%",
                    backgroundColor: "gray",
                    margin: "30px 0 0 0",
                  }}
                />
                <Grid container alignItems="end" sx={{ marginBottom: "30px" }}>
                  <Grid size={{ xs: 12 }}>
                    {values?.travelerPickup?.pins?.length > 0 ||
                    values?.logistics?.travelerPickup?.pins?.length > 0 ? (
                      <AvailabilityPickupPanel
                        setFieldValue={setFieldValue}
                        // availabilities={allTravelerPickups}
                        availabilities={values?.travelerPickup || values?.logistics?.travelerPickup}
                      />
                    ) : (
                      <MDBox sx={{ marginTop: "30px" }}>
                        <MDTypography variant="h5">No Availability Found!</MDTypography>
                        {errors?.availabilities && touched?.availabilities && (
                          <Danger validation={errors?.availabilities} />
                        )}
                      </MDBox>
                    )}
                  </Grid>
                </Grid>
              </>
            )}
            <Grid size={{ xs: 12 }}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <GreenSwitch
                      checked={allowCustomTravelerPickupV}
                      name={allowCustomTravelerPickup.name}
                      onChange={(event) => {
                        setFieldValue("allowCustomTravelerPickup", event.target.checked);
                        setFieldValue(
                          "logistics.travelerPickup.allowCustomTravelerPickup",
                          event.target.checked
                        );
                      }}
                    />
                  }
                  label="Allow travellers to define their pickup points."
                />
              </FormGroup>
            </Grid>
            <Grid size={{ xs: 12 }} style={{ marginTop: "10px" }}>
              <FormField
                // type={additionalPickupInfo.type}
                label={additionalPickupInfo.label}
                name={additionalPickupInfo.name}
                value={additionalPickupInfoV}
                multiline
                outlined
                rows={5}
                placeholder={additionalPickupInfo.placeholder}
                // error={errors.additionalPickupInfo && touched.additionalPickupInfo}
                success={additionalPickupInfoV?.length > 0 && !errors?.additionalPickupInfo}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <FormField
                type={minutesBeforeDepartureTimeForPickup.type}
                label={minutesBeforeDepartureTimeForPickup.label}
                name={minutesBeforeDepartureTimeForPickup.name}
                value={minutesBeforeDepartureTimeForPickupV}
                placeholder={minutesBeforeDepartureTimeForPickup.placeholder}
                isPadding={false}
                success={
                  minutesBeforeDepartureTimeForPickupV?.length > 0 &&
                  !errors.minutesBeforeDepartureTimeForPickup
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span style={{ fontSize: "0.85rem" }}>minutes</span>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </MDBox>
        )}
      </ShowHideComponentsPicker>
      <ShowHideComponentsPicker title="Additional information">
        {detailPage && editPage ? (
          <DetailList
            data={{
              additionalInfo: values?.additionalInfo,
            }}
          />
        ) : (
          <PhysicalRestrictionsSection
            values={values}
            setFieldValue={setFieldValue}
            selectedAdditionalInfo={selectedAdditionalInfo}
            handleAdditionalInfoChange={handleAdditionalInfoChange}
            restrictions={restrictions}
            handleHealthRestrictionChange={handleHealthRestrictionChange}
            healthRestrictions={healthRestrictions}
            physicalDifficultyLevelV={physicalDifficultyLevelV}
            radioOptions={radioOptions}
            helperTextStyle={helperTextStyle}
          />
        )}
      </ShowHideComponentsPicker>
      <ShowHideComponentsPicker title="Badges">
        {" "}
        {detailPage && editPage ? (
          <DetailList
            data={{
              badges: getBadgeLabel(values?.badges),
              highlight: values?.highlight,
              top: values?.top,
            }}
          />
        ) : (
          <MDBox mt={1.625}>
            <Grid size={{ xs: 6 }}>
              <BadgePicker
                badge={badge}
                badgeV={
                  Array.isArray(values?.badges) && values.badges.length > 0
                    ? values?.badges?.[0]
                    : values?.badges
                }
                setFieldValue={setFieldValue}
                // error={errors.badge && touched.badge}
                success={values?.badge && !errors.badge}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <GreenSwitch
                      checked={topV}
                      name={top.name}
                      onChange={(event) => setFieldValue("top", event.target.checked)}
                    />
                  }
                  label="Top"
                />
                <FormControlLabel
                  control={
                    <GreenSwitch
                      checked={highlightV}
                      name={highlight.name}
                      onChange={(event) => setFieldValue("highlight", event.target.checked)}
                    />
                  }
                  label="Highlight"
                />
              </FormGroup>
            </Grid>
          </MDBox>
        )}
      </ShowHideComponentsPicker>
    </>
  );
};

Content.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.func]).isRequired,
  editPage: PropTypes.bool,
  handleVenueChange: PropTypes.func,
  handlePinChange: PropTypes.func,
  handlePickupPointChange: PropTypes.func,
  handleTitleIncChange: PropTypes.func,
  handleTitleExcChange: PropTypes.func,
  selectedTitleInc: PropTypes.instanceOf(Object),
  selectedTitleExc: PropTypes.instanceOf(Object),
  selectedPin: PropTypes.instanceOf(Object),
  setSelectedPin: PropTypes.func,
  setSelectedVenue: PropTypes.func,
  selectedPickupPoint: PropTypes.instanceOf(Object),
  setSelectedPickupPoint: PropTypes.func,
  setSelectedTitleExc: PropTypes.func,
  setSelectedTitleInc: PropTypes.func,
  selectedVenue: PropTypes.instanceOf(Object),
  detailPage: PropTypes.bool,
};

export default Content;
